import React from "react";
import moment from "moment";
import { ChevronsUp, ChevronsDown, Filter as FilterIcon } from "lucide-react";

import { Input } from "../../../../components/ui/Form/Input";
import { Filter } from "../../../../components/ui/Filter";
import { CAMPO } from "../../../../components/ui/Filter/sizes";
import { PurchaseReportController } from "../../../../services/controllers/reports";
import { usePurchaseReports } from "../../../../store/reports/usePurchaseReport";
import { Select } from "../../../../components/ui/Form/Select";

/**
 * Antes os campos ficavam em duas linhas fixas com o botao preso dentro da
 * primeira (ml-auto), o que desalinhava tudo. Agora segue o mesmo desenho dos
 * outros relatorios: campos no Filter.Container, acoes no Filter.Actions.
 */
export function PurchaseReportFilter() {
  const CPurchaseReport = PurchaseReportController();
  const filter = usePurchaseReports((st) => st.data.filter);
  const sort = usePurchaseReports((st) => st.data.sort);
  const isLoading = usePurchaseReports((st) => st.data.isLoading);

  return (
    <Filter.Root onSubmit={CPurchaseReport.filterPurchases}>
      <Filter.Container>
        <Input.Root
          pickDate
          label="Início"
          value={moment(filter.dateFrom).format("DD/MM/YYYY")}
          onChange={(dateFrom) => CPurchaseReport.setFilter({ ...filter, dateFrom })}
        />

        <Input.Root
          pickDate
          label="Fim"
          value={moment(filter.dateTo).format("DD/MM/YYYY")}
          onChange={(dateTo) => CPurchaseReport.setFilter({ ...filter, dateTo })}
        />

        <Input.Root
          label="Produto"
          style={CAMPO.grande}
          defaultValue={filter.description}
          onChange={(description) => CPurchaseReport.setFilter({ ...filter, description })}
        />

        <Input.Root
          label="Marca"
          style={CAMPO.grande}
          defaultValue={filter.brand}
          onChange={(brand) => CPurchaseReport.setFilter({ ...filter, brand })}
        />

        <Select.Root
          label="Departamento"
          style={CAMPO.grande}
          value={filter.department}
          onChange={(department) => CPurchaseReport.setFilter({ ...filter, department })}
        >
          <Select.Option value={"*"}>Todos</Select.Option>
          <Select.Option value={"USO E CONSUMO"}>Uso e consumo</Select.Option>
          <Select.Option value={"CASA E JARDIM"}>Casa e jardim</Select.Option>
          <Select.Option value={"ACESSORIOS"}>Acessórios</Select.Option>
          <Select.Option value={"OUTROS ALIMENTOS"}>Outros alimentos</Select.Option>
          <Select.Option value={"ALIMENTOS COMPLETOS"}>Alimentos completos</Select.Option>
          <Select.Option value={"MEDICAMENTOS"}>Medicamentos</Select.Option>
          <Select.Option value={"HIGIENE E LIMPEZA"}>Higiene e limpeza</Select.Option>
          <Select.Option value={"SERES VIVOS"}>Seres vivos</Select.Option>
        </Select.Root>

        <Select.Root
          label="Ordem"
          style={CAMPO.grande}
          value={sort.field}
          onChange={(field) => CPurchaseReport.setSort({ ...sort, field })}
        >
          <Select.Option value={"*"}>Padrão</Select.Option>
          <Select.Option value={"suggestion-purchase"}>Sugestão de compra</Select.Option>
          <Select.Option value={"abc"}>Curva ABC</Select.Option>
          <Select.Option value={"invoicing"}>Faturamento</Select.Option>
          <Select.Option value={"sale"}>Quantidade</Select.Option>
          <Select.Option value={"marca"}>Marca</Select.Option>
        </Select.Root>

        <Select.Root
          label="Direção"
          style={CAMPO.pequeno}
          value={sort.direction}
          onChange={(direction) => CPurchaseReport.setSort({ ...sort, direction })}
        >
          <Select.Option value={"1"}>
            <ChevronsUp />
          </Select.Option>
          <Select.Option value={"-1"}>
            <ChevronsDown />
          </Select.Option>
        </Select.Root>
      </Filter.Container>

      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
          Filtrar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="clear-purchase-report"
          disabled={isLoading}
          onClick={CPurchaseReport.clearFilter}
        >
          Limpar
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
